import { createSlice } from "@reduxjs/toolkit";

const subscriptionSlice = createSlice({
  name: "subscriptionSlice",
  initialState: {
    priceList: [],
    discount: null,
    stripeDirectUrl: "",
  },
  reducers: {
    setPriceList: (state, action) => {
      state.priceList = action?.payload;
    },
    setDiscount: (state, action) => {
      state.discount = action?.payload;
    },
    setStripeRedirectURL: (state, action) => {
      state.stripeDirectUrl = action?.payload;
    },
  },
});

// this is for dispatch
export const { setPriceList, setDiscount, setStripeRedirectURL } =
  subscriptionSlice.actions;

// this is for configureStore
export default subscriptionSlice.reducer;
